import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { SettingService } from './setting.service';
import { set } from 'lodash';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class ERPService {
	public defMap:any;
	public productMap:any;
	public datas: DataService;
	public sts: SettingService;
	public subscribedProducts:any = [];
	constructor(private injector: Injector) {
		this.loadJsonMap();
	}

	ngOnInt(){
		
	}

	loadJsonMap(){
		this.datas = this.injector.get(DataService);
		let url = '//' + location.host + '/RainbowOne/webapp/erp.json?t=' + +new Date();
		if (url.indexOf('localhost:4200') > -1){
			url = url.replace(location.host,"dev.openknowledge.hk");
		}
		if (!this.defMap) this.defMap = {};
		if (!this.productMap) this.productMap = {};
		let urls = [ url, url.replace('erp.json', 'entitlement.json')];
		urls.forEach(fileUrl=>{
			this.datas.get(fileUrl).subscribe((res:any)=>{
				for(let fullKey in res){
					const parts = fullKey.split('_');
					const prop = fullKey.substring(fullKey.indexOf('_') + 1, fullKey.lastIndexOf('_'));
					const product = parts[parts.length - 1];
	
					if (product == 'def'){
						this.defMap[prop] = res[fullKey];
					} else if (this.productMap[product]){
						this.productMap[product][prop] = res[fullKey];
					} else {
						this.productMap[product] = {};
						this.productMap[product][prop] = res[fullKey];
					}
				}
			}, (error)=>{
	
			});
		});
		
	}

	mergeSettings(settings){
		if (!this.defMap){
			return settings;
		}
		const sts = this.injector.get(SettingService);
		for(let prop in this.defMap){
			if (sts.byDef[prop] || /[a-z]/.test(prop)){ //erp的key必有小寫, schoolSetting必定大寫.
				settings[prop] = this.defMap[prop];
			}
		}
		const plan = this.datas.userInfo?.school?.plan_type;
		if (plan && this.productMap && this.productMap[plan]){
			for(const prop in this.productMap[plan]){
				if (sts.byDef[prop] || /[a-z]/.test(prop)){
					settings[prop] = this.productMap[plan][prop];
				}
			}
		}
		let keys = [...this.subscribedProducts, 'a:' + this.datas.appId2];
		if (this.datas.userInfo){
			keys.push('s:' + this.datas.userInfo.school_id);
		}
		keys.forEach(k=>{
			if (this.productMap && this.productMap[k]){
				for(const prop in this.productMap[k]){
					if (sts.byDef[prop] || /[a-z]/.test(prop)){
						settings[prop] = this.productMap[k][prop];
					}
				}
			}
		});
		const coms = this.injector.get(CommonService);
		coms.waitFor(()=> this.datas.userInfo, 10, 100).then(()=>{
			const schoolIdKey = 's:' + this.datas.userInfo.school_id;
			if (this.productMap && this.productMap[schoolIdKey]){
				for(const prop in this.productMap[schoolIdKey]){
					if (sts.byDef[prop] || /[a-z]/.test(prop)){
						settings[prop] = this.productMap[schoolIdKey][prop];
					}
				}
			}
		});
	}

}
